import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Paper, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faHistory } from '@fortawesome/free-solid-svg-icons';
import CitationSettings from '../components/settings/CitationSettings';
import { getCitationSettings } from '../services/api';
import Loader from '../components/common/Loader';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`citation-tabpanel-${index}`}
      aria-labelledby={`citation-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const CitationsPage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const [citationsEnabled, setCitationsEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const clientId = localStorage.getItem('client_id') || '';

  useEffect(() => {
    checkCitationStatus();
  }, []);

  const checkCitationStatus = async () => {
    try {
      setLoading(true);
      const data = await getCitationSettings(clientId);
      
      if (data.success) {
        setCitationsEnabled(data.citations_enabled);
      }
    } catch (error) {
      console.error("Error checking citation status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  if (loading) {
    return (
      <div className="h-full min-h-[400px] relative">
        <Loader 
          fullPage={false} 
          text="Loading citation settings..." 
          variant="pulse"
          overlay={true} 
        />
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Citation Settings</h1>
        <Box>
          {citationsEnabled && (
            <Button 
              component={Link} 
              to="/citation-analytics" 
              color="primary" 
              variant="outlined" 
              startIcon={<FontAwesomeIcon icon={faChartBar} />}
              sx={{ mr: 2 }}
            >
              View Analytics
            </Button>
          )}
          <Button 
            component={Link} 
            to="/chat-history" 
            color="primary" 
            variant="outlined" 
            startIcon={<FontAwesomeIcon icon={faHistory} />}
          >
            View Chat History
          </Button>
        </Box>
      </div>

      <Paper className="bg-white rounded-lg shadow p-6">
        <CitationSettings 
          clientId={clientId} 
          onStatusChange={(enabled: boolean) => setCitationsEnabled(enabled)}
        />
      </Paper>
    </div>
  );
};

export default CitationsPage; 